/* coffee-feature.js */
document.addEventListener('DOMContentLoaded', function () {
  try {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, { threshold: 0.18 });

    document.querySelectorAll('.reveal').forEach(function (el) {
      observer.observe(el);
    });
  } catch (e) {
    // browsers antiguos: mostrar sin animación
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }
});
